import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import _ from "lodash";

import Filter from "../components/Filter";
import Socket from "../../../socket/socket";
import {
  set_opt_details,
  set_event_details,
  set_create_opt_phase,
  set_custom_opt_types
} from "../../../redux/opt/action";
import { setIsLoading } from "../../../redux/loader/action";
import { ReactComponent as BroSvg } from "../../../assets/images/opt/bro.svg";
import { ReactComponent as EditEventSvg } from "../../../assets/images/opt/edit-event.svg";
import { ReactComponent as OptionsSvg } from "../../../assets/images/opt/options.svg";
import { ReactComponent as ListFilterSvg } from "../../../assets/images/opt/list-filter.svg";
import { ReactComponent as DeleteEventSvg } from "../../../assets/images/opt/delete-event.svg";
import filterIcon from "../../../assets/images/opt/filter-icon.png";

const opt_filters = [
  {
    name: "Event",
    key: "title"
  },
  {
    name: "Type",
    key: "type"
  },
  {
    name: "Category",
    key: "category"
  },
  {
    name: "Date",
    key: "start_timestamp"
  },
  {
    name: "Duration",
    key: "duration"
  }
];
const EventList = ({
  history,
  team_opts,
  setSelectedUsers,
  onDeleteModalOpen,
  event_list_params
}) => {
  const dispatch = useDispatch();
  const {
    gameReducer: {
      currentUser: { team: { id } = "" }
    }
  } = useSelector((state) => state);

  const table_text = _.get(event_list_params, "table_text", "Team Events");
  const table_button = _.get(event_list_params, "table_button", "Add Event");
  const empty_text = _.get(
    event_list_params,
    "empty_text",
    "No Outside Events to display. Add an outside event to view and edit here."
  );

  const [teamOpts, setTeamOpts] = useState([]);
  const [sortedOpts, setSortedOpts] = useState([]);
  const [filterOpen, setFilterOpen] = useState({
    title: false,
    type: false,
    category: false,
    start_timestamp: false,
    duration: false
  });
  const [optionSelect, setOptionSelect] = useState({ value: "", data: {} });
  const [initialFilterArray, setInitialFilterArray] = useState([]);

  const handleToggleLoading = (value) => {
    dispatch(setIsLoading(value));
  };

  useEffect(() => {
    dispatch(set_create_opt_phase("one"));
    dispatch(
      set_event_details({
        title: "",
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
        start_timestamp: "",
        end_timestamp: "",
        type: "",
        category: "",
        participants: []
      })
    );
  }, []);

  useEffect(() => {
    let array = [];
    initialFilterArray.forEach((filter) => {
      filter.array.forEach((item) => {
        if (item.selected) {
          let sub_array = team_opts.filter((opt) => {
            if (isNaN(opt[item.key])) {
              return opt[item.key] === item.value;
            } else {
              if (item.key === "duration") {
                return opt[item.key] / (1000 * 60) === item.value;
              } else {
                return moment(opt[item.key]).format("M/D/YYYY") === item.value;
              }
            }
          });
          array = [...array, ...sub_array];
        }
      });
      let uniqueArray = [...new Set(array.map((item) => item.opt_id && item))];

      !_.isEmpty(uniqueArray)
        ? setTeamOpts(uniqueArray)
        : setTeamOpts(
            [...team_opts].sort((a, b) => b.start_timestamp - a.start_timestamp)
          );
    });
  }, [team_opts, initialFilterArray]);

  useEffect(() => {
    let initialArray = [...teamOpts];
    let flag = false;
    initialFilterArray.forEach((filter) => {
      filter.sortArray.map((item) => {
        if (item.selected) {
          flag = true;
          if (
            item.key === "title" ||
            item.key === "type" ||
            item.key === "category"
          ) {
            if (item.value === "A -> Z") {
              initialArray.sort((a, b) => (a[item.key] > b[item.key] ? 1 : -1));
            } else {
              initialArray.sort((a, b) => (a[item.key] < b[item.key] ? 1 : -1));
            }
          } else if (item.key === "duration") {
            if (item.value === "Ascending") {
              initialArray.sort((a, b) => a[item.key] - b[item.key]);
            } else {
              initialArray.sort((a, b) => b[item.key] - a[item.key]);
            }
          } else {
            if (item.value === "Ascending") {
              initialArray.sort(
                (a, b) =>
                  moment(a[item.key]).valueOf() - moment(b[item.key]).valueOf()
              );
            } else {
              initialArray.sort(
                (a, b) =>
                  moment(b[item.key]).valueOf() - moment(a[item.key]).valueOf()
              );
            }
          }
        }
      });
    });
    flag ? setSortedOpts(initialArray) : setSortedOpts([]);
  }, [teamOpts, initialFilterArray]);

  useEffect(() => {
    setTeamOpts(
      [...team_opts].sort((a, b) => b.start_timestamp - a.start_timestamp)
    );
  }, [team_opts]);

  useEffect(() => {
    return Socket.addListener(
      "opt-options-get",
      handle_opt_options_get,
      handle_opt_options_get_error
    );
  }, [optionSelect]);

  const handle_opt_options_get = (res) => {
    if (res && optionSelect.value !== "") {
      dispatch(set_custom_opt_types(res.opt_types));
      setSelectedUsers([]);
      handleToggleLoading(false);
      if (optionSelect.value === "add") {
        dispatch(set_opt_details({}));
        history.push({
          pathname: `/outside_team_building/add_event`
        });
      } else {
        dispatch(set_opt_details(optionSelect.data));
        history.push({
          pathname: `/outside_team_building/edit/${optionSelect.data.opt_id}`
        });
      }
    }
  };

  const handle_opt_options_get_error = () => {
    handleToggleLoading(false);
  };

  const handleGetOptTypes = () => {
    handleToggleLoading(true);
    const data = {
      action: "opt-options-get",
      team_code: id
    };
    Socket.sendMessage(data);
  };

  useEffect(() => {
    optionSelect.value !== "" && handleGetOptTypes();
  }, [optionSelect]);

  const handleEditEvent = (opt) => {
    setOptionSelect((prev) => ({ ...prev, value: "edit", data: opt }));
  };

  const handleAddEvent = () => {
    setOptionSelect((prev) => ({ ...prev, value: "add" }));
  };

  const convertedDate = (epoch_time) => moment(epoch_time).format("MM/DD/YYYY");

  const convertedTime = (time) => {
    const hour = Math.floor(time / 60);
    const minutes = time % 60;
    if (hour > 0) {
      return `${hour > 1 ? hour + " hours" : hour + " hour"}${
        minutes
          ? minutes === 1
            ? " " + minutes + " min"
            : " " + minutes + " mins"
          : ""
      }`;
    } else {
      return `${minutes} mins`;
    }
  };

  const handleFilterClick = (key) => {
    let array = [...initialFilterArray];
    Object.keys(filterOpen).map((item) =>
      setFilterOpen((prev) => ({
        ...prev,
        [item]: item === key ? !filterOpen[key] : false
      }))
    );

    if (key === "title" || key === "type" || key === "category") {
      let uniqueArray = [...new Set(team_opts.map((item) => item[key]))].map(
        (item) => ({ value: item, key: key, selected: false })
      );

      !array.some((item) => item.key === key) &&
        setInitialFilterArray(() => [
          ...array,
          {
            key: key,
            array: uniqueArray,
            sortArray: [
              { value: "A -> Z", key: key, selected: false },
              { value: "Z -> A", key: key, selected: false }
            ]
          }
        ]);
    } else if (key === "start_timestamp") {
      const uniqueDates = [
        ...new Set(
          team_opts.map((item) => moment(item[key]).format("M/D/YYYY"))
        )
      ]
        .sort(
          (a, b) =>
            moment(a, "M/D/YYYY").valueOf() - moment(b, "M/D/YYYY").valueOf()
        )
        .map((date) => ({ value: date, key: key, selected: false }));
      !array.some((item) => item.key === key) &&
        setInitialFilterArray([
          ...array,
          {
            key: key,
            array: uniqueDates,
            sortArray: [
              { value: "Ascending", key: key, selected: false },
              { value: "Descending", key: key, selected: false }
            ]
          }
        ]);
    } else {
      const uniqueTime = [
        ...new Set(team_opts.map((item) => item[key] / (1000 * 60)))
      ]
        .sort((a, b) => a - b)
        .map((time) => ({
          value: time,
          key: key,
          selected: false
        }));

      !array.some((item) => item.key === key) &&
        setInitialFilterArray([
          ...array,
          {
            key: key,
            array: uniqueTime,
            sortArray: [
              { value: "Ascending", key: key, selected: false },
              { value: "Descending", key: key, selected: false }
            ]
          }
        ]);
    }
  };

  const handleSelectFilter = (filter) => {
    let array = initialFilterArray.map((item) => ({
      ...item,
      array: item.array.map((c) =>
        c.value === filter.value ? { ...c, selected: !c.selected } : c
      ),
      sortArray: item.sortArray.map((c) => ({ ...c, selected: false }))
    }));
    setInitialFilterArray(array);
  };

  const handleSelectSort = (sortItem) => {
    let array = initialFilterArray.map((item) => ({
      ...item,
      sortArray: item.sortArray.map((c) =>
        c.value === sortItem.value && c.key === sortItem.key
          ? { ...c, selected: !c.selected }
          : { ...c, selected: false }
      )
    }));
    setInitialFilterArray(array);
  };

  return (
    <div className="ddd">
      <div className="list-top">
        <h2>{table_text}</h2>
        <div className="add-event-buttons">
          {/* <button className="import-btn">Import</button> */}
          <button className="create-new-btn" onClick={handleAddEvent}>
            Create New
          </button>
        </div>
      </div>
      <div className="opt-list-div">
        {!_.isEmpty(teamOpts) && (
          <div className="list-header-div">
            <div className="event-list-div">
              {opt_filters.map((item, index) => (
                <div
                  key={index}
                  className="event-data-name filter"
                  onClick={() => handleFilterClick(item.key)}
                >
                  <h2 className="event-text-data filter">{item.name}</h2>
                  {/* <ListFilterSvg fill="#000" className="filter-icon" /> */}
                  <img alt="" src={filterIcon} className="event-filter-icon" />
                  {filterOpen[item.key] && (
                    <Filter
                      convertedTime={convertedTime}
                      onSelectSort={handleSelectSort}
                      onSelectFilter={handleSelectFilter}
                      sortArray={
                        initialFilterArray.find((c) => c.key === item.key)
                          .sortArray
                      }
                      filterArray={
                        initialFilterArray.find((c) => c.key === item.key).array
                      }
                    />
                  )}
                </div>
              ))}
              <div className="last-columns"></div>
            </div>
          </div>
        )}
        <div className="list-container">
          {_.isEmpty(teamOpts) ? (
            <div className="event-list-empty">
              <BroSvg className="bro-icon" />
              <h2 className="empty-list-text">
                No Team Events to display.{" "}
                <span onClick={handleAddEvent}>Add Event</span> to view and edit
                here.
              </h2>
            </div>
          ) : (
            <>
              {!_.isEmpty(sortedOpts)
                ? sortedOpts.map((opt, index) => (
                    <div key={index} className="event-list-div">
                      <div className="event-data-name">
                        <h2 className="event-text-data name">{opt.title}</h2>
                      </div>
                      <div className="event-data-name">
                        <h2 className="event-text-data">{opt.type}</h2>
                      </div>
                      <div className="event-data-name">
                        <h2 className="event-text-data">{opt.category}</h2>
                      </div>
                      <div className="event-data-name">
                        <h2 className="event-text-data">
                          {convertedDate(opt.start_timestamp)}
                        </h2>
                      </div>
                      <div className="event-data-name">
                        <h2 className="event-text-data">
                          {convertedTime(opt.duration / (1000 * 60))}
                        </h2>
                      </div>
                      <div
                        className="event-icon-div"
                        onClick={() => handleEditEvent(opt)}
                      >
                        <EditEventSvg className="event-icon" />
                      </div>
                      <div
                        className="event-icon-div"
                        onClick={() => onDeleteModalOpen(opt)}
                      >
                        <DeleteEventSvg className="event-icon" />
                      </div>
                    </div>
                  ))
                : teamOpts.map((opt, index) => (
                    <div key={index} className="event-list-div">
                      <div className="event-data-name">
                        <h2 className="event-text-data name">{opt.title}</h2>
                      </div>
                      <div className="event-data-name">
                        <h2 className="event-text-data">{opt.type}</h2>
                      </div>
                      <div className="event-data-name">
                        <h2 className="event-text-data">{opt.category}</h2>
                      </div>
                      <div className="event-data-name">
                        <h2 className="event-text-data">
                          {convertedDate(opt.start_timestamp)}
                        </h2>
                      </div>
                      <div className="event-data-name">
                        <h2 className="event-text-data">
                          {convertedTime(opt.duration / (1000 * 60))}
                        </h2>
                      </div>
                      <div
                        className="event-icon-div"
                        onClick={() => handleEditEvent(opt)}
                      >
                        <EditEventSvg className="event-icon" />
                      </div>
                      <div
                        className="event-icon-div"
                        onClick={() => onDeleteModalOpen(opt)}
                      >
                        <DeleteEventSvg className="event-icon" />
                      </div>
                    </div>
                  ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventList;
